import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { discordLoginUrl } from "@/lib/api";
import { useAuthStore } from "@/lib/auth-store";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";

export function LoginRoute() {
  const me = useAuthStore((s) => s.me);
  const loaded = useAuthStore((s) => s.loaded);
  const nav = useNavigate();
  const [params] = useSearchParams();
  const error = params.get("error");

  useEffect(() => {
    if (loaded && me) nav("/", { replace: true });
  }, [loaded, me, nav]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-card border border-border rounded-lg p-8 space-y-6">
        <div className="space-y-1.5">
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-primary shadow-[0_0_10px_hsl(var(--primary)/0.45)]" />
            <span className="font-semibold text-foreground/95">EPICON2 Moderation</span>
          </div>
          <h1 className="text-xl font-semibold text-foreground">Sign in</h1>
          <p className="text-sm text-muted-foreground">
            Authorized Discord accounts only.
          </p>
        </div>

        {error && (
          <Alert variant="destructive">
            <AlertDescription>
              {error === "not_allowlisted"
                ? "Your Discord account is not on the admin allowlist."
                : error === "oauth_failed"
                ? "Discord rejected the sign-in."
                : `Sign-in failed: ${error}`}
            </AlertDescription>
          </Alert>
        )}

        <Button asChild className="w-full bg-[#5865F2] hover:bg-[#4752C4] text-white">
          <a href={discordLoginUrl()}>Continue with Discord</a>
        </Button>
      </div>
    </div>
  );
}
